import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import TimeIntervalStep from "../../../../../../../shared/wizard/steps/timeIntervalStep";
import { EDealRequestTimeInterval } from "../../../../../../../shared/wizard/steps/types";

interface ISureBuyStepBuy_4 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SureBuyStepBuy_4 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISureBuyStepBuy_4) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.sureSteps.buy.step_3);
    onReset(["timeIntervalTypeView"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.sureSteps.buy.step_5);
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="view"
        text="Желаемое время просмотра:"
      />
    </div>
  );
};

export default SureBuyStepBuy_4;
